import {
  ToggleButtonGroup,
  ToggleButton
} from '@mui/material';

import classes from './classes.module.scss';

import {
  AND_OPERATOR,
  OR_OPERATOR
} from 'app/hooks/useFilter';

const FilterOperatorToggle = props => {
  const {
    defaultValue,
    onChange,
    sx
  } = props;

  return (
    <ToggleButtonGroup
      exclusive
      value={defaultValue}
      onChange={(event, operator) => {
        onChange(operator);
      }}
      sx={sx}
    >
      <ToggleButton className={classes.toggleButton} value={AND_OPERATOR}>AND</ToggleButton>
      <ToggleButton className={classes.toggleButton} value={OR_OPERATOR}>OR</ToggleButton>
    </ToggleButtonGroup>
  )
}

export default FilterOperatorToggle;
